import React, { Component } from 'react'
import { Textfit } from 'react-textfit'
import './App.css'

class App extends Component {
  render() {
    return (
      <div className="App" style={{
        position: "absolute",
        width: "calc(100vw - 2 * 4rem)",
        top: "50%",
        padding: "0 4rem",
        lineHeight: "120%",
        transform: "translateY(-50%)"
      }}>
        <Textfit mode="single">
          <h1>Få mere ud af sociale medier</h1>
          <p><em>af</em></p>
          <h2><b>Trine-Maria Kristensen</b></h2>
          <p>Udkommer september 2017</p>
        </Textfit>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js